/* eslint-disable */
import { useEffect } from 'react'
import { useRecoilState } from 'recoil'
import { noticeScrollState } from '../atoms'
import Board from '../components/board'
export default function Notice(props){
  let [noticeScroll] = useRecoilState(noticeScrollState)
  useEffect(() => {
    window.scrollTo({top : noticeScroll, behavior : 'smooth'})
  }, [])
  return(
    <div className="contents">
      <div className="content-title02">공지사항</div>
      <Board list={props.noticeList}/>
      {
        props.noticeList.length == 0 ?
        <div className='no-employ'>등록된 공지사항이 없습니다.</div> : ''
      }
    </div>
  )
}